/** PROTOTYPE project metadata card -- THROWAWAY. Customer / title / reference; feeds the documents. */
import React from 'react';
import { CRC } from './moduleInputsData';
import { Label } from './protoAtoms';
import { ProjectState } from './spreadSplitData';

const card: React.CSSProperties = { background: '#fff', border: `1px solid ${CRC.border}`, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.04)', padding: 20 };
const textBox: React.CSSProperties = { width: '100%', padding: '8px 10px', fontFamily: 'inherit', fontSize: 14, color: CRC.blueprintBlue, border: `1px solid ${CRC.border}`, borderRadius: 8 };

interface Props { project: ProjectState; setProject: (p: ProjectState) => void; }

export const ProjectDetailsCard: React.FC<Props> = ({ project, setProject }) => {
  const field = (label: string, value: string, onChange: (v: string) => void) => (
    <div style={{ flex: '1 1 220px' }}><Label>{label}</Label><div style={{ marginTop: 4 }}>
      <input title={label} type="text" value={value} onChange={(e) => onChange(e.target.value)} style={textBox} />
    </div></div>
  );
  return (
    <div style={card}>
      <div style={{ fontFamily: 'Funnel Sans', fontSize: 15, fontWeight: 600, color: CRC.blueprintBlue, marginBottom: 4 }}>Project details</div>
      <div style={{ fontSize: 12, color: CRC.heritageGrey, marginBottom: 14 }}>Shown on every generated document (header, customer and reference).</div>
      <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
        {field('Customer name', project.customerName, (v) => setProject({ ...project, customerName: v }))}
        {field('Project title', project.projectTitle, (v) => setProject({ ...project, projectTitle: v }))}
        {field('Reference number', project.refNumber, (v) => setProject({ ...project, refNumber: v }))}
      </div>
    </div>
  );
};
